var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSendVoiceBtn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.393,
    height: 15.117,
    viewBox: "0 0 17.393 15.117",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.013,34.109a.51.51,0,0,1,.68-.583l16.373,6.25a.51.51,0,0,1,0,.951l-4.6,1.776v5.6a.51.51,0,0,1-.965.229L9.6,44.554,4.959,48a.51.51,0,0,1-.791-.261C-.167,33.527.02,34.145.013,34.109ZM4.055,35.9l7.976,5.68,3.432-1.325Zm7.394,6.517L4.5,37.466c5.983,6.311,5.67,5.979,5.7,6.014.039.052-.067-.151,1.256,2.476ZM4.932,46.75l4.086-3.033L1.629,35.923Z",
    transform: "translate(-0.001 -33.492)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendVoiceBtn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-voice-btn.69703b6b.svg";
export { ForwardRef as ReactComponent };